import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import PokazRozkladForm from "../../konfiguracja/rozkladConfig/rozklad/pokazRozklad/components/PokazRozkladForm";
import DefinicjeService from "../../konfiguracja/trasyConfig/definicjeTras/DefinicjeService";
import TrasyService from "../../konfiguracja/trasyConfig/trasy/TrasyService";
import KalendarzDoDatyService from "../../konfiguracja/rozkladConfig/kalendarze/przypisanieKalendarzaDoDaty/KalendarzDoDatyService";
import DataFormat from "../../../utilities/DateAndTimeFormat";
import DefinicjaGodzinyStartowejService from "../../konfiguracja/rozkladConfig/definicjeGodzinStartowychjDlaTrasy/DefinicjaGodzinyStartowejService";
import RozkladService from "../../konfiguracja/rozkladConfig/rozklad/RozkladService";
import UrzadRozkladTable from "./components/UrzadRozkladTable";

export default class UrzadRozkladContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rozklad: [],
            trasy: [],
            params: '',
            iloscRekordow: -1,
            obecna_trasa: null,
            obecna_data: null,
            czyByloSzukanie: false,
            definicjeTras: [],
            pierwszy_przystanek: null,
            czyBylaZmianaSzukania:false,
        };

        this.pobierzTrasy = this.pobierzTrasy.bind(this)
        this.getKalendarzDoDaty = this.getKalendarzDoDaty.bind(this)
        this.getGodziny = this.getGodziny.bind(this)
        this.szukajGodzin = this.szukajGodzin.bind(this)
        this.szukajWRozkladzie = this.szukajWRozkladzie.bind(this)
        this.pobierzPierwszyPrzystanekNaTrasie = this.pobierzPierwszyPrzystanekNaTrasie.bind(this)
    }

    componentDidMount() {
        this.pobierzTrasy()
    }

    pobierzPierwszyPrzystanekNaTrasie(trasa){
        DefinicjeService.pobierzPierwszyPrzystanekNaTrasie(trasa.idTr).then(function (response) {
            this.setState({pierwszy_przystanek:response.data})
        }.bind(this))
    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content})
        }.bind(this))
    }

    getKalendarzDoDaty(trasa, data) {
        KalendarzDoDatyService.getDatyZKalendarzami(DataFormat.formatYYYYMMDD(data), DataFormat.formatYYYYMMDD(data)).then(function (response) {
            if (response.data.length > 0) {
                this.getGodziny(trasa.idTr, response.data[0].idRk)
            }
        }.bind(this))
    }

    getGodziny(trasa_id, kalendarz_id) {

        DefinicjaGodzinyStartowejService.getGodzinyWTrasieIKalendarzu(trasa_id, kalendarz_id).then(function (response) {
            this.setState({godziny: response.data})
        }.bind(this))

    }

    szukajGodzin(trasa, data) {
        this.getKalendarzDoDaty(trasa, data)
        this.setState({obecna_trasa: trasa, obecna_data: data, czyByloSzukanie: false})
        this.pobierzPierwszyPrzystanekNaTrasie(trasa)
    }

    szukajWRozkladzie(data, trasa, godzina) {
        this.setState({czyByloSzukanie: true})
        let params;
        if (data !== null && trasa !== null) {
            params = 'data=' + data + '&idTr=' + trasa.idTr;
        }
        if (data === null && trasa === null) {
            params = this.state.params
        }
        this.setState({params: params})
        RozkladService.getSzukajRozkladPierwszePrzystanki(0, 999999, params).then(function (response) {

            this.setState({rozklad: response.data.content, iloscRekordow: response.data.totalElements, czyBylaZmianaSzukania:true})
        }.bind(this))

    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'UrzadContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/urzad', text: 'Urząd'},{addressUrl: '/urzad/rozklad', text: 'Rozkład jazdy'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz} history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={8}>
                            <PokazRozkladForm trasy={this.state.trasy}
                                              handleSzukajGodzin={this.szukajGodzin}
                                              godziny={this.state.godziny}
                                              handleSzukaj={this.szukajWRozkladzie}/>
                        </Col>
                        <Col sm={12}>
                            {
                                (this.state.iloscRekordow > -1)?
                                    <UrzadRozkladTable data={this.state.rozklad} pagination={false}
                                                       czyBylaZmianaSzukania={this.state.czyBylaZmianaSzukania}
                                                       wylaczZmianeSzukania={()=>{this.setState({czyBylaZmianaSzukania:false})}}/>
                                    :
                                    ''
                            }
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/rozklad/UrzadRozkladContainer.js